import Cookies from "js-cookie";

export function getToken() {
  return Cookies.get("JK-TOEKN");
}

export function setToken(token) {
  return Cookies.set("JK-TOEKN", token, { expires: 10 });
}

export function removeToken() {
  return Cookies.remove("JK-TOEKN");
}

export function getRoles() {
  let v = Cookies.get("JK-ROLES");
  if (v) {
    return JSON.parse(v);
  }
  return [];
}

export function setRoles(v) {
  return Cookies.set("JK-ROLES", JSON.stringify(v), { expires: 10 });
}

export function removeRoles() {
  return Cookies.remove("JK-ROLES");
}
